export default "__VITE_ASSET__CwwhkODv__"